import React, { useState } from "react";
import styles from "./FinancialsTab.module.css";

const FinancialsFilterBar = ({ filters, setFilters, onApply, onReset }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (e) => setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  return (
    <div className={styles.filtersBar}>
      <div className={styles.filtersRow}>
        <label>من تاريخ
          <input type="date" name="from" value={filters.from} onChange={handleChange} />
        </label>
        <label>إلى تاريخ
          <input type="date" name="to" value={filters.to} onChange={handleChange} />
        </label>
        <label>الشهر
          <select name="month" value={filters.month} onChange={handleChange}>
            <option value="">الكل</option>
            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </label>
        <label>السنة
          <input type="number" name="year" placeholder="2026" value={filters.year} onChange={handleChange} />
        </label>

        <button type="button" className={styles.toggleBtn} onClick={() => setExpanded((p) => !p)}>
          {expanded ? "إخفاء الإعدادات المتقدمة ▲" : "إعدادات متقدمة ▼"}
        </button>
      </div>

      {expanded && (
        <div className={styles.filtersRow}>
          <label>نسبة التسليم المتوقعة (%)
            <input
              type="number" step="0.01" name="expectedDeliveryPercentage"
              placeholder="75" value={filters.expectedDeliveryPercentage} onChange={handleChange}
            />
          </label>
          <label>نسبة تكلفة المنتج المخصص
            <input
              type="number" step="0.01" name="customProductCostRatio"
              placeholder="0.4" value={filters.customProductCostRatio} onChange={handleChange}
            />
          </label>
          <label>نسبة عمولة الوكالة (%)
            <input
              type="number" step="0.01" name="agencyCommissionPercentage"
              placeholder="10" value={filters.agencyCommissionPercentage} onChange={handleChange}
            />
          </label>
        </div>
      )}

      <div className={styles.filterActions}>
        <button className={styles.applyBtn} onClick={onApply}>تطبيق الفلاتر</button>
        <button className={styles.resetBtn} onClick={onReset}>إعادة تعيين</button>
      </div>
    </div>
  );
};

export default FinancialsFilterBar;